export class Program {
  id?: string;
  name: string;
  // cardTypeName: string;
  // cardTypeId: number;
  startDate: number;
  endDate: number;
  hasDispersionMax: boolean;
  dispersionMaxAmount: number;
  hasCardDispersionMax: boolean;
  cardDispersionMaxAmount: number;
  dateCreated: number;
  companyCosts?: {
    programSetup: number;
    monthlyCost: number;
    dispersionCost: number;
    cardCreation: number;
    yearlyCost: number;
    cardReplacement: number;
  };
  userCosts?: {
    monthlyCost: number;
    cardCreation: number;
    yearlyCost: number;
    transactionCost: number;
    virtualWireingCost: number;
    bankWireingCost: number;
  };

  constructor(formData?: any) {
    let data: any = !formData ? {} : formData;

    this.id = data.id || null;
    this.name = data.name || null;
    // this.cardTypeName = data.cardTypeName || null;
    // this.cardTypeId = data.cardTypeId || null;
    this.startDate = data.startDate || null;
    this.endDate = data.endDate || null;
    this.hasDispersionMax = data.hasDispersionMax || false;
    this.dispersionMaxAmount = data.dispersionMaxAmount || null;
    this.hasCardDispersionMax = data.hasCardDispersionMax || false;
    this.cardDispersionMaxAmount = data.cardDispersionMaxAmount || null;
    this.dateCreated = data.dateCreated || null;
    this.companyCosts = data.companyCosts || {
      programSetup: 0,
      monthlyCost: 0,
      dispersionCost: 0,
      cardCreation: 0,
      yearlyCost: 0,
      cardReplacement: 0
    },
      this.userCosts = data.userCosts || {
        monthlyCost: 0,
        dispersionCost: 0,
        cardCreation: 0,
        yearlyCost: 0,
        transactionCost: 0,
        virtualWireingCost: 0,
        bankWireingCost: 0,
      };
  }
}
